import runtime from './settlement-path-art.json';
import type { IslandPoint, IslandQuad } from './settlement-island-registration';
import type { SettlementPublicPath } from './settlement-public-paths';

/** Flat ground only: projected by the same homography as plots, never an upright sprite. */
export const settlementPathMaterial = {
  id: 'settlement_limestone_footpath_v1',
  ...runtime['limestone-footpath-v1'],
  reviewStatus: 'needs_cultural_review',
  provenance: 'openai_builtin_imagegen_v1',
  groundDiameter: 0.44,
} as const;

export interface SettlementPathStamp {
  districtCode: string;
  center: IslandPoint;
  ground: IslandQuad;
}

/** Overlapping feathered stone patches, never an opaque rectangular road surface. */
export function settlementPathStamps(
  paths: readonly SettlementPublicPath[],
): SettlementPathStamp[] {
  const result: SettlementPathStamp[] = [];
  const seen = new Set<string>();
  const radius = settlementPathMaterial.groundDiameter / 2;
  for (const path of paths.slice(0, 12)) {
    for (let index = 1; index < path.points.length && result.length < 288; index++) {
      const a = path.points[index - 1]!;
      const b = path.points[index]!;
      const length = Math.hypot(b.x - a.x, b.y - a.y);
      if (!Number.isFinite(length) || length <= 0 || length > 6) continue;
      const count = Math.ceil(length / 0.3);
      for (let step = 0; step <= count && result.length < 288; step++) {
        const x = a.x + ((b.x - a.x) * step) / count;
        const y = a.y + ((b.y - a.y) * step) / count;
        const key = `${path.districtCode}:${x.toFixed(4)}:${y.toFixed(4)}`;
        if (seen.has(key)) continue;
        seen.add(key);
        result.push({
          districtCode: path.districtCode,
          center: { x, y },
          ground: [
            { x: x - radius, y: y - radius },
            { x: x + radius, y: y - radius },
            { x: x + radius, y: y + radius },
            { x: x - radius, y: y + radius },
          ],
        });
      }
    }
  }
  return result;
}
